import { render, staticRenderFns } from "./AdminListing.vue?vue&type=template&id=05584cb0&"
import script from "./AdminListing.vue?vue&type=script&lang=js&"
export * from "./AdminListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports